const cloudServicesData = [
  {
    title: "Cloud Consulting",
    description:
      "Expert guidance to navigate your cloud journey. We assess needs and build a tailored roadmap to maximize efficiency and performance.",
    bullets: [
      "Expert Guidance",
      "Clear Roadmap",
      "Tailored Strategies",
      "Cloud Readiness Assessment",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud Migration",
    description:
      "Seamlessly migrate systems with minimal disruption. We plan, execute, and validate end‑to‑end migrations.",
    bullets: [
      "Seamless transition",
      "Testing & validation",
      "Operational continuity",
      "Expert execution",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud Application Development",
    description:
      "Custom, secure, and scalable cloud applications built for performance and future growth.",
    bullets: [
      "Custom Application",
      "Scalable Development",
      "Performance Oriented",
      "Enhanced operations",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud Security",
    description:
      "Protect infrastructure and data with assessments, compliance, monitoring, and threat management.",
    bullets: [
      "Regular Updates",
      "Data Protection and Encryption",
      "Security Assessment & Compliance",
      "Threat Detection & Response",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud Storage Solutions",
    description:
      "Flexible, high‑availability storage with secure, fast access tailored to your needs.",
    bullets: [
      "Scalable Storage",
      "Fast Access",
      "Secure Solutions",
      "Flexible Options",
    ],
    minHeight: 420,
  },
  {
    title: "DevOps Solutions",
    description:
      "Accelerate delivery with CI/CD, automation, and collaborative workflows for faster releases.",
    bullets: [
      "Improved Collaboration",
      "Continuous Integration & Deployment",
      "Automated Processes",
      "Faster Releases",
    ],
    minHeight: 420,
  },
  {
    title: "Managed Cloud Services",
    description:
      "24/7 monitoring, security, and support to keep your cloud optimized and aligned with goals.",
    bullets: [
      "Seamless Operations",
      "Expert Management",
      "Comprehensive Security",
      "Aligned with Business Goals",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud Infrastructure Services & Monitoring",
    description:
      "Design, implementation, maintenance, and continuous monitoring for reliable, high‑performance infrastructure.",
    bullets: [
      "Tailored Architecture Design",
      "High‑Performance Infrastructure",
      "Ongoing Maintenance",
      "Backup and disaster recovery",
    ],
    minHeight: 420,
  },
  {
    title: "Cloud Cost Optimization",
    description:
      "Analyze usage and reduce costs with continuous monitoring and optimization—without sacrificing performance.",
    bullets: [
      "Cost Analysis",
      "Expense Management",
      "Performance Optimization",
      "Budget Alignment",
    ],
    minHeight: 420,
  },
];

export default cloudServicesData;

// Cloud platform wide cards for ScrollStack section
export const cloudPlatformCards = [
  {
    title: "Amazon Web Services (AWS)",
    image: "/assets/img/cloud/aws.jpg",
    body: "Advisory, architecture, and secure migrations on AWS. We build reliable, scalable foundations across networking, security, data, and DevOps.",
  },
  {
    title: "Microsoft Azure",
    image: "/assets/img/cloud/Microsoft Azure.webp",
    body: "Modernize and run faster on Azure: application refactoring, managed data platforms, observability, and governance for enterprise workloads.",
  },
  {
    title: "Google Cloud Platform (GCP)",
    image: "/assets/img/cloud/Google Cloud.jpg",
    body: "Leverage GCP for data engineering, analytics, and AI/ML on secure, cost‑efficient infrastructure with automated pipelines.",
  },
];
